// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_2toyy","image":"_2IBfT","info":"_2lTRn","title":"_1B4-g","description":"_1HGBc"};